export default "__VITE_ASSET__4908bc13__"